"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var colorConfig_1 = require("./colorConfig");
exports.getMax = function (arr) { return arr.length - 1; };
exports.getShadeStr = function (shades, sliderVal) { return shades[sliderVal]; };
var ShaderSlider = function (_a) {
    var onChangeFn = _a.onChangeFn, sliderVal = _a.sliderVal;
    var max = exports.getMax(colorConfig_1.colorShades);
    var shadeStr = exports.getShadeStr(colorConfig_1.colorShades, sliderVal);
    return (react_1.default.createElement(core_1.Box, null,
        react_1.default.createElement(core_1.Slider, { defaultValue: colorConfig_1.defaultColorShadeIndex, "aria-labelledby": 'shade-slider', onChange: onChangeFn, step: 1, min: 0, max: max }),
        react_1.default.createElement(core_1.Typography, null, shadeStr)));
};
exports.default = ShaderSlider;
